import * as Yup from 'yup';

/**
 * Schema: dimensionSchema
 * 
 * This schema defines the validation rules for a dimension object using Yup.
 * 
 * @property {number} length - The length of the dimension (required, minimum value of 1).
 * @property {string} position - The position of the dimension (required, one of 'ABSOLUTE' or 'RELATIVE').
 */
const dimensionSchema = Yup.object().shape({
  length: Yup.number()
    .required('Length is required')
    .moreThan(0, 'Length must be bigger than 1.'),
  position: Yup.string()
    .oneOf(['ABSOLUTE', 'RELATIVE'])
    .required('Position is required'),
});

/**
 * Function: getWindowTypeStructureSchema
 * 
 * This function returns a Yup schema for validating the structure of a window type object.
 * The schema includes validation rules for name, style, height, sill height, width, description, and category.
 * 
 * @returns {Yup.ObjectSchema} The Yup schema for validating a window type structure.
 */
export const getWindowTypeStructureSchema = () => {
  const windowTypeStructureSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    style: Yup.string().oneOf(['ISOLATED', 'WALL_TO_WALL']).required('Style is required'),
    height: dimensionSchema.required('Height is required'),
    sillHeight: dimensionSchema.required('Sill height is required'),
    width: dimensionSchema.required('Width is required'),
    description: Yup.string().optional(),
    category: Yup.string().oneOf(['WINDOWS']).required('Category is required'),
  });

  return windowTypeStructureSchema;
};
